import axios from "axios";
import { plainToInstance } from "class-transformer";
import { authenticatedApiConfig } from "./BaseApiService";
import { PatientGuidedConsentsDto } from "healthex-common/patient.dtos";
export class GuidedConsentService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async getAllPatientGuidedConsentForOrganization(organizationId) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/guided-consent/${organizationId}/all`, await authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(PatientGuidedConsentsDto, response.data);
    }
}
